export const getAllCategoriesReducers=(state={categories:[]},action)=>{

    switch(action.type)
    {
        case 'GET_CATEGORIES_REQUEST':return{
            loading:true,
            ...state
        }
        case 'GET_CATEGORIES_SUCCESS':return{
            loading:false,
            categories:action.payload
        }
        case 'GET_CATEGORIES_FAILED':return{
            error:action.payload,
            loading:false
        }
        default:return state
    }
}